import React from 'react';
import styles from './Header.module.scss';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <div className={styles.messageTop}>Happy 24th birthday</div>
          <div className={styles.nameTop}>SeoHyeon</div>
        </div>
        <div className={styles.nav}>
          <Link to='/'>
            <div className={styles.home}>💖</div>
          </Link>
          <Link to='letter'>
            <div className={styles.letter}>💌</div>
          </Link>
          <Link to='photo'>
            <div className={styles.photo}>📸</div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Header;
